export const BRAND = 'BRAND';
export const PROGRAM = 'PROGRAM';
export const CATEGORY = 'CATEGORY';
export const ITEM_TYPE = 'ITEM_TYPE';
export const CHANNEL = 'CHANNEL';

